export default {"src":"/_next/static/media/cards-icon-9.4e5c4d4f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};